import { UserInfo } from '@microsoft/teamsfx';

import { AppError } from 'src/errors';
import { ErrorCodes } from 'src/utils/enums';
import { ERROR_MESSAGES } from 'src/utils/constants';

type GlobalErrorConstructorParms = {
  message: string
  source?: string
  lineno?: number
  colno?: number
  user?: UserInfo | null
  originalError?: Error
  context?: Record<string, unknown>
};

export class GlobalError extends AppError {
  constructor({ message, source, lineno, colno, user, originalError, context }: GlobalErrorConstructorParms) {
    const newContext = {
      source,
      lineno,
      colno,
      ...context,
    };

    super({ name: 'GlobalError', message, errorCode: ErrorCodes.GLOBAL, user, originalError, context: newContext });
  }
}

export function handleGlobalError(message: string | Event, source?: string, lineno?: number, colno?: number, error?: Error, user?: UserInfo): void {
  if (error instanceof AppError && error.isLogged) {
    return;
  }

  let errorMessage = '';
  const eventType = message instanceof Event ? message.type : 'Unknown Event';

  if (error instanceof Error) {
    errorMessage = ERROR_MESSAGES.globalError(error.message);
  }
  else if (typeof message === 'string') {
    errorMessage = ERROR_MESSAGES.globalError(message);
  }
  else {
    errorMessage = ERROR_MESSAGES.globalError(`${eventType}: ${message}`);
  }

  const errorInstance = new GlobalError({ message: errorMessage, source, lineno, colno, user, originalError: error });

  errorInstance.logError();
}
